// extracted by mini-css-extract-plugin
module.exports = {"machineHours":"MachineHours_machineHours_2COZ_","gray":"MachineHours_gray_1A9Xd"};